<div class="tabs">
    <button *ngFor="let tab of tabs" (click)="selectTab(tab.label)" [ngClass]="{ active: selectedTab() === tab.label }">
        <mat-icon class="tab-icon">{{ tab.icon }}</mat-icon>
        {{ tab.label }}
    </button>
</div>

<!-- Mostrar término de búsqueda si existe -->
<div *ngIf="searchQuery()" class=" search-info px-5 py-2 text-[#134F82]">
    <p class="headline-05">
        Resultados para: <strong>"{{ searchQuery() }}"</strong>
    </p>
</div>

<div class="mt-6 px-5">
    <!-- TODOS -->
    <ng-container *ngIf="selectedTab() === 'Todos'; else filteredView">
        <div *ngIf="servicesByTipo.length === 0" class="no-results p-8 text-center">
            <h3 class="text-lg font-semibold text-gray-600 mb-2">No se encontraron servicios</h3>
            <p class="text-gray-500">Intenta con otros términos de búsqueda</p>
        </div>

        <ng-container *ngFor="let group of servicesByTipo">
            <div class="mb-8">
                <div class="flex items-center gap-2 mb-1">
                    <mat-icon class="tit-icon">{{ group.icon }}</mat-icon>
                    <h2 class="text-lg font-semibold">Asistencia {{ group.tipo.toLowerCase() }}</h2>
                </div>
                <p *ngIf="!searchQuery()" class="subtitulo">Todo lo necesario para tu salud integral</p>

                <div class="card-wrapper" [class.single-card]="group.servicios.length === 1">
                    <div *ngFor="let service of group.servicios" class="card" (click)="goToService(service)">
                        <div class="image-container">
                            <img [src]="service.imagen" alt="{{ service.nombre }}"/>
                            <div class="info-overlay">
                                <div class="text">
                                    <div class="nombre">{{ service.nombre }}</div>
                                  <div class="subtitle">{{ formatUsage(service.Tomados, service.Disponibles) }} utilizados</div>
                                </div>
                                <mat-icon class="arrow" fontIcon="arrow_circle_right">arrow_circle_right</mat-icon>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </ng-container>

        <!-- Publicidad -->
        <!--div class="mt-10" *ngIf="servicesByTipo.length > 0">
            <img src="assets/images/publicidad/banner.png" alt="Publicidad" class="w-full rounded-xl shadow mb-4 cursor-pointer" (click)="goToBeneficios()" />
        </div-->

    </ng-container>

    <ng-template #filteredView>
        <p *ngIf="!searchQuery()" class="subtitulo">Todo lo necesario para tu salud integral</p>

        <div class="card-grid" [class.single-card-grid]="filteredServices.length === 1">
            <div *ngIf="filteredServices.length === 0" class="no-results p-8 text-center">
                <h3 class="text-lg font-semibold text-gray-600 mb-2">No se encontraron servicios</h3>
                <p class="text-gray-500">Intenta con otros términos de búsqueda</p>
            </div>
            <div *ngFor="let service of filteredServices.slice(0, 5)" class="card" (click)="goToService(service)">
                <div class="image-container">
                    <img [src]="service.imagen" alt="{{ service.nombre }}" />
                    <div class="info-overlay">
                        <div class="text">
                            <div class="nombre">{{ service.nombre }}</div>
                            <div class="uso">{{ formatUsage(service.Tomados, service.Disponibles) }} utilizados</div>
                        </div>
                        <mat-icon class="arrow" fontIcon="arrow_circle_right">arrow_circle_right</mat-icon>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div *ngIf="selectedTab() === 'Médica'" class="otros-servicios">
            <h3 class="otros-title">Otros servicios médicos</h3>
            <div *ngFor="let item of otrosServiciosMedicos" class="otros-card">
                <div class="textos">
                    <div class="nombre">{{ item.nombre }}</div>
                    <div class="uso">{{ item.uso }}</div>
                </div>
                <mat-icon class="flecha">arrow_forward_ios</mat-icon>
            </div>
        </div> -->

        <!-- Publicidad -->
        <div class="mt-10">

        </div>
        <!--div class="mt-10" *ngIf="selectedTab() === 'Médica'">
            <img src="assets/images/publicidad/banner-medica.png" alt="Publicidad" class="w-full rounded-xl shadow mb-4 cursor-pointer" (click)="goToBeneficios()" />
        </div>
        <div class="mt-10" *ngIf="selectedTab() === 'Vial'">
            <img src="assets/images/publicidad/banner-vial.png" alt="Publicidad" class="w-full rounded-xl shadow mb-4 cursor-pointer" (click)="goToBeneficios()" />
        </div-->

    </ng-template>
    <app-floating-assistance-button></app-floating-assistance-button>
</div>
